import React from 'react';

export function Card({ children, className = '' }) {
    return (
        <div className={`card-base ${className}`}>
            {children}
        </div>
    );
}

export function CardHeader({ children, className = '' }) {
    return (
        <div className={`px-4 py-3 border-b border-slate-200 dark:border-slate-700 ${className}`}>
            {children}
        </div>
    );
}

export function CardBody({ children, className = '', style }) {
    return (
        <div className={`p-4 ${className}`} style={style}>
            {children}
        </div>
    );
}

export function CardFooter({ children, className = '' }) {
    return (
        <div className={`px-4 py-3 border-t border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 ${className}`}>
            {children}
        </div>
    );
}
